// todo - JAMES - refactor this file, all these interfaces/classes have been copied verbatim from DataBus
import { Component, OnInit, QueryList, EventEmitter } from '@angular/core';
import { Widget,Dashboard } from 'src/api/models'
import { WidgetComponent } from '../views/dashboard/widgets/widget/widget.component';

export class DashboardSelection{
  public dashboardId: number;
  public dashboardIdentifier: string;
  public siteUri: string;
  public size: number;
  public displayName: string;
}

export class WidgetSelection{
  public dashboardId: number;
  public siteUri: string;
  public size: number;
  public displayName: string;
  public widget: Widget;
  public data: any;
}

export class EventStatistics {
  lastRequestTime: any;
}

export class BaseEvent {
  uri: string;
  series: SharedSeries;
  point: SharedPoint;
}

export class SharedPoint {
  uri: string;
  registered: boolean;
  events: Event[];
  value: any;
  metaData: any;
  timeStamp: string;
  shortTimeStamp: string;

  updated: Promise<SharedPoint>;
}

export class SharedSeries {
  uri: string;
  index: number;
  dynamicIndex: number;
  name: string;
  description: string;
  siteName: string;
  siteDescription: string;
  metaData?: {[key: string]: string};
  registered: boolean;
  from: string;
  to: string;
  debug: string;
  latitude: number;
  longitude: number;
  values: SharedPoint[];
  statistics: EventStatistics;
}

export class WidgetType {
  name: string;
  type: string;
  description: string;
  component: any;
  editor: any;
  blank: any;
  icon: string;
  admin: boolean;
}

export interface IWidget {
  widget: Widget;
  dashboard: Dashboard;
  uri: string;
  //siteUri: string;
  widgetComponent: WidgetComponent;
  state: any;
  dashboardSelected: EventEmitter<DashboardSelection>;
  //widgetSelected: EventEmitter<WidgetSelection>;

  loadComplete(force: boolean): void;
}

export interface IWidgetEditor {
  widgetType: WidgetType;
  widget: Widget;
  dashboard: Dashboard;
  siteUri?: string;
}

export class TimeSeriesDetail {
  uri: string;
  virtualTimeSeriesId: number;
  siteUri: string;
  tagMatches: TagMatch[];

  type: string;
  forceEmbed: boolean;
  sourceType: string;
  
  transforms: TransformConfig[];
}

export class TagMatch {
  isNew: boolean;
  tagName: string;
  tagValue: string;
}

export class TransformConfig{
  id: string;
  parameters: TransformParameter[]
}

export class TransformParameter{
  name: string;
  value: string;
}

export interface ISingleSourceSingleValueWidget {
  timeSeries: TimeSeriesDetail;
}

export interface IMultiSourceSingleValueWidget {
  timeSeriesList: TimeSeriesDetail[];
}

export interface IMultiSourceMultiValueWidget {
  realTime: boolean;
  period: string;
  refreshInterval: number;
  timeSeriesList: TimeSeriesDetail[];
  dynamicTimeSeriesList: TimeSeriesDetail[];
}

export interface IDataSourceAssociatedSingleValueWidget {
  dataSourceUri: string;
}

export interface queryString {
  period?: string,
    timeSeries?: timeSeriesQuery[]
}

export interface timeSeriesQuery {
  uri: string,
  options: {
    color?: string,
    lineWidth?: number,
    type?: string,
    dashStyle?: string,
    yAxis?: number
  }
}

export class DataAnalysisConfig {
  period: string;
  from: string;
  to: string;
  leftMin: number;
  leftMax: number;
  rightMin: number;
  rightMax: number;
  offset: number;

  protected static SInit = (() => {
    DataAnalysisConfig.prototype.offset = 600;
    DataAnalysisConfig.prototype.period = "yesterday";
  })();

  timeSeriesList: DataAnalysisTimeSeries[];
}

export class DataAnalysisTimeSeries {
  uri: string;
  axis: number;
  type: string;
  style: string;
  width: number;
  active: boolean;
  color: string;
  data: SharedSeries;
  // input: InputItem; todo - james - Don't think input item is probably required here?
  series: any; //highcharts series

  protected static SInit = (() => {
    DataAnalysisTimeSeries.prototype.axis = 0;
    DataAnalysisTimeSeries.prototype.width = 1;
    DataAnalysisTimeSeries.prototype.type = "line";
    DataAnalysisTimeSeries.prototype.style = "solid";
  })();
}

// Widget Types
class BaseWidget implements Widget {
  height: number;
  name?: string;
  size: number;
  type?: string;
  showCategories: boolean;
  widgetId: number;
  showTitle: boolean;
  refreshInterval: number;
  hidden: boolean;
  hideWhenNoData: boolean;
}

// New Line Widget
export class NewLineWidget extends BaseWidget {
  showLine: boolean;
}

//Clock Widget
export class ClockWidget extends BaseWidget
{
  twentyfour: boolean;
  fontSize: number;
}

//Overdue Sites Widget
export class OverdueSitesWidget extends BaseWidget
{
  siteTypeCode: string;
  minHeight: number;
  minThresholdHours: number;
  maxThresholdDays: number;
}

// Wind Rose Widget
export class WindRoseWidget extends BaseWidget {
  period: string;
  windSegmentSize: number;
  showLegend: boolean;
}

// Media Widget
export class MediaWidget extends BaseWidget {
  timeSeriesList: TimeSeriesDetail[];
  period: string;
  carouselEnabled: Boolean;
  showImageMetaData: Boolean;
  autoPlayVideo: Boolean;
}

// Time Lapse Widget
export class TimeLapseWidget extends BaseWidget {
  timeSeriesList: TimeSeriesDetail[];
  period: string;
  timeScroller: Boolean;
  showImageMetaData: Boolean;
  hideImagesWithoutMetaData: Boolean | undefined;
}

// Chart Widget
export class ChartWidget extends BaseWidget{
  showLegend: boolean;
}

// Map Widget
export class MapWidget extends BaseWidget {
  iconRule: MapIconRule;
  onLive: MapOnEvent;
  onLoad: MapOnEvent;
  onClick: MapOnEvent;
  onDblClick: MapOnEvent;
  onRClick: MapOnEvent;
}

export enum MapIconRuleOperators {
  GreaterThan = "Greater Than",
    LessThan = "Less Than",
    EqualTo = "Equal To",
    NotEqualTo = "Not Equal To",
}

export class MapIconRule {
  falseIcon: string;
  trueIcon: string;
  operator: string;
  inputValue: string;
}

export class MapRuleSelectInput {
  inputItemUri: string;
  kmlUrl: string;
}

export class MapOnEvent {
  constructor(placeholder: string = "// asset.uri, asset.latitude, asset.longitude, asset.name, asset.pinIconUrl, asset.animation, asset.point") {
    this.function = placeholder;
  }

  function: string;
}

export class MapAsset {
  public uri: string;
  public latitude: number;
  public longitude: number;
  public name: string;
  public animation: string;
  public shortValue: string;
  public point: SharedPoint;
  public loaded: boolean;
  public widget?: Widget;
}
